import React from "react";

export default function Overview({
  nominalpendapatan,
  nominalpendapatansebelumnya,
  nominalpiutang,
  nominalpiutangsebelumnya,
}) {
  const persentasePendapatan =
    +(
      Math.round(
        ((nominalpendapatan - nominalpendapatansebelumnya) /
          nominalpendapatansebelumnya) *
          100 +
          "e+2"
      ) + "e-2"
    ) ?? 0;
  const persentasePiutang =
    +(
      Math.round(
        ((nominalpiutang - nominalpiutangsebelumnya) /
          nominalpiutangsebelumnya) *
          100 +
          "e+2"
      ) + "e-2"
    ) ?? 0;
  const overview = [
    {
      name: "Total Pendapatan",
      nominal: nominalpendapatan ?? 0,
      persentase: persentasePendapatan,
      nominal_tahun_sebelumnya: nominalpendapatansebelumnya ?? 0,
      class:
        "group p-4 md:p-8 rounded-lg border border-neutral-300 text-black hover:border-primary-main bg-white content-center hover:bg-primary-main hover:text-white duration-300",
      label_class:
        "inline-block align-middle text-xs md:text-sm px-1 md:px-2 py-1 mb-1 md:ml-2 font-semibold rounded-full " +
        (persentasePendapatan > 0
          ? "text-primary-dark bg-primary-third"
          : "text-danger bg-danger-light"),
    },
    {
      name: "Total Piutang",
      nominal: nominalpiutang ?? 0,
      persentase: persentasePiutang,
      nominal_tahun_sebelumnya: nominalpiutangsebelumnya ?? 0,
      class:
        "group p-4 md:p-8 rounded-lg border border-neutral-300 text-black hover:border-danger bg-white content-center hover:bg-danger hover:text-white duration-300",
      label_class:
        "inline-block align-middle text-xs md:text-sm px-1 md:px-2 py-1 mb-1 md:ml-2 font-semibold rounded-full " +
        (persentasePiutang > 0
          ? "text-danger bg-danger-light"
          : "text-primary-dark bg-primary-third"),
    },
  ];

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {overview.map((val) => (
          <div className={val.class}>
            <h4 className="text-base md:text-xl font-semibold">{val.name}</h4>
            <h2 className="text-lg md:text-3xl font-semibold">
              Rp. {val.nominal.toLocaleString()}
              <span className={val.label_class}>{val.persentase}%</span>
            </h2>
            <h5 className="text-sm md:text-base font-semibold text-gray-dark group-hover:text-white">
              Compared to Rp. {val.nominal_tahun_sebelumnya.toLocaleString()}{" "}
              last year
            </h5>
          </div>
        ))}
      </div>
    </>
  );
}
